import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { default as PerformanceMetricsVirtualizedTable } from "./PerformanceMetricsVirtualizedTable";

export class PerformanceMetricsTableGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: []
    }
  }

  componentWillReceiveProps(nextProps) {

    if(this.props.scorecards !== nextProps.scorecards) {
      if(nextProps.scorecards !== undefined && nextProps.scorecards.length > 0) {
        let updatedColumns = []

        nextProps.scorecards.forEach(c => {
            updatedColumns.push({
              label: c.scorecardDisplayName,
              percentage: ""
            })
        })
        this.setState({
          columns: updatedColumns
        });
      }
    }
  }

  componentDidMount() {
    
      if(this.props.scorecards !== undefined && this.props.scorecards.length > 0) {
        let updatedColumns = []

        this.props.scorecards.forEach(c => {          
            updatedColumns.push({
              label: c.scorecardDisplayName,
              percentage: ""
            })
        })
        this.setState({
          columns: updatedColumns
        });
      }
  }

  render() {
    let { columns } = this.state;
    let { displayTable, viewScorecard, currentTabSelectedData, scorecards } = this.props;
    return (
      <div className={ displayTable ? "table-container" : "table-container hide"} >
        <PerformanceMetricsVirtualizedTable
          columns={columns}
          currentTabSelectedData={ currentTabSelectedData+'MU'}
          tableName={'Management Units'}
          viewScorecard={  viewScorecard }
          scorecards={ scorecards }
        />
        <PerformanceMetricsVirtualizedTable
          columns={columns}
          currentTabSelectedData={ currentTabSelectedData+"Team"}
          tableName={'Teams'}
          viewScorecard={  viewScorecard }
          scorecards={ scorecards }
        />
        <PerformanceMetricsVirtualizedTable
          columns={columns}
          currentTabSelectedData={ currentTabSelectedData+"Agent"}
          tableName={'Agents'}
          viewScorecard={  viewScorecard }
          scorecards={ scorecards }
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    scorecards: state.scorecard.scorecards,
    displayTable: state.scorecard.displayTable
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsTableGrid);



// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsTableGrid.js